/*
 * Implementation that takes into account the scroll position when
 * retrieving a DOM elements position via `getBoundingClientRect`.
 *
 * https://stackoverflow.com/a/32623832
*/

/* tslint:disable */
export default function absolutePosition(el) {
    let
        found,
        left = 0,
        top = 0,
        width = 0,
        height = 0,
        offsetBase = (absolutePosition as any).offsetBase;
    if (!offsetBase && document.body) {
        offsetBase = (absolutePosition as any).offsetBase = document.createElement('div');
        offsetBase.style.cssText = 'position:absolute;left:0;top:0';
        document.body.appendChild(offsetBase);
    }
    if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
        var boundingRect = el.getBoundingClientRect();
        var baseRect = offsetBase.getBoundingClientRect();
        found = true;
        left = boundingRect.left - baseRect.left;
        top = boundingRect.top - baseRect.top;
        width = boundingRect.right - boundingRect.left;
        height = boundingRect.bottom - boundingRect.top;
    }
    return {
        found: found,
        left: left,
        top: top,
        width: width,
        height: height,
        right: left + width,
        bottom: top + height
    };
}